import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import type { SvgIconTypeMap } from '@mui/material/SvgIcon';
import type { OverridableComponent } from '@mui/types';
import { ReactComponent as WeChatSvg } from 'assets/icons/socialmedia/wechat.svg';

const WeChatIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon ref={ref} component={WeChatSvg} inheritViewBox {...props} />
)) as OverridableComponent<SvgIconTypeMap<Record<string, never>, 'svg'>>;

(WeChatSvg as any).muiName = 'SvgIcon';

export default WeChatIcon;
